import React, { createContext, useContext, useState, useEffect } from 'react';

const HIGHLIGHT_PRESETS = {
  lavender:  { rgb: '124, 92, 232',   label: 'Lavender' },
  rosepetal: { rgb: '212, 30, 52',    label: 'Red Rose Petals' },
  champagne: { rgb: '232, 110, 130',  label: 'Pink Champagne' },
  emerald:   { rgb: '0, 165, 80',     label: 'Emerald Green' },
  gold:      { rgb: '220, 168, 30',   label: '24k Gold' },
  navy:      { rgb: '30, 58, 138',    label: 'Navy Blue' },
};

const ANSWER_PRESETS = {
  adaptive: { label: 'Fade to match clues' },
  blue:     { label: 'Blue',  dark: '#2B95E0', light: '#0050B0' },
  dark:     { label: 'Match clues' },
  teal:     { label: 'Teal',  dark: '#008C86', light: '#0A6E66' },
  green:    { label: 'Green', dark: '#25A044', light: '#0F7332' },
};

const DEFAULTS = {
  highlightStyle: 'shade',
  highlightColor: 'lavender',
  answerStyle: 'adaptive',
  numpadSide: 'right',
  autoValidate: false, // when on, silently re-checks the grid after every placement
  soundEffects: true,  // play the victory piano riff on puzzle completion
};

const GamePreferencesContext = createContext();

export function GamePreferencesProvider({ children }) {
  const [prefs, setPrefs] = useState(() => {
    try {
      const saved = localStorage.getItem('sudoku-game-prefs');
      return saved ? { ...DEFAULTS, ...JSON.parse(saved) } : DEFAULTS;
    } catch {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    localStorage.setItem('sudoku-game-prefs', JSON.stringify(prefs));
  }, [prefs]);

  const updatePref = (key, value) => {
    setPrefs(prev => ({ ...prev, [key]: value }));
  };

  return (
    <GamePreferencesContext.Provider value={{
      prefs,
      updatePref,
      HIGHLIGHT_PRESETS,
      ANSWER_PRESETS,
    }}>
      {children}
    </GamePreferencesContext.Provider>
  );
}

export function useGamePreferences() {
  return useContext(GamePreferencesContext);
}

export { HIGHLIGHT_PRESETS, ANSWER_PRESETS };
